import { fetchApi } from '../utils/fetchApi'

export const verifyRoleAdmin = () => fetchApi({
  path: '/verify/admin',
})

export const verifyRoleFacm = () => fetchApi({
  path: '/verify/facm',
})

export const verifyRoleEval = () => fetchApi({
  path: '/verify/eval',
})
